import React, {Component} from 'react';
import './Hours.css';
import PersonTermCell from '../Terms/Terms'
import axios from "../../../axios-cmk";
import {connect} from 'react-redux';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import {baseMappingWithPersonsAndHours} from '../../../store/mappings'
import {addMinutes} from "../../../store/utility";

const mapDispatchToProps = dispatch => {
    return {}
}

class HourRowBase extends Component {
    render() {
        const halfAnHour = addMinutes(new Date(), this.props.hour.start, 30)
        return (
            <div className="rTableRow hourRow">
                <div className="rTableCell">
                    {this.props.hour.start}<br />
                    <div className="halfAnHour">{halfAnHour.format("HH:mm")}</div>
                </div>
                {this.props.therapists.map(therapist => (
                    <div className='rTableCell hourBox' key={therapist.id}>
                        <PersonTermCell
                            key={therapist.id}
                            therapist={therapist}
                            hour={this.props.hour}
                        />
                    </div>
                ))}
            </div>
        )
    }
}

const HourRow = connect(baseMappingWithPersonsAndHours, mapDispatchToProps)(HourRowBase);

class HoursGrid extends Component {
    render() {
        return (
            <div className="rTable">
                <div className="rTableRow">
                    <div className="rTableHead columnHeader">Godzina</div>
                    {this.props.therapists.map(therapist => (
                        <div className="rTableHead columnHeader" key={therapist.id}>
                            {therapist.first_name} <br/>
                            <small>{therapist.last_name.split(" ")[0]}</small>
                        </div>
                    ))}
                </div>
                {
                    this.props.plan_hours.map(plan_hour => {
                        if (plan_hour.shown) {
                            return <HourRow
                                key={plan_hour.id}
                                hour={plan_hour}
                            />
                        }
                        return ''
                    })
                }
            </div>
        )
    }
}

export default connect(baseMappingWithPersonsAndHours, mapDispatchToProps)(withErrorHandler(HoursGrid, axios));



// WEBPACK FOOTER //
// ./src/components/Calendar/Hours/Hours.js